import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useChapterCompletion } from '@openclassrooms/data-connect-web/chapters';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import { translate } from '@openclassrooms/translations';
import CourseNavigationFooter from './CourseNavigationFooter';
import CategoryButton from './CategoryButton';
import { useChapterContext } from '../_contexts/ChapterContext';
import getNextChapter from '../_utils/getNextChapter';
import getFooterInformation from '../_utils/getFooterInformation';
const CourseFooterWrapper = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    course,
    flatToc,
    currentChapter
  } = useChapterContext();
  const {
    userId
  } = useCurrentUserContext();
  const [, {
    mutateAsync: completeChapterAsync
  }] = useChapterCompletion();
  if (!course) return null;
  if (!currentChapter) return null;
  const {
    categoryColor
  } = course;
  const currentChapterId = currentChapter.id;
  if (!currentChapterId) return null;
  const nextChapter = getNextChapter(flatToc as any, currentChapterId);
  const {
    label,
    url
  } = getFooterInformation(course, nextChapter, searchParams?.toString());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    router.prefetch(url);
  }, [router, url]);
  const handleChapterCompletion = () => {
    if (userId && !currentChapter.isCompleted && currentChapterId) {
      completeChapterAsync(currentChapterId).then(() => router.refresh());
    }
    router.push(url);
  };
  return <CourseNavigationFooter categoryColor={categoryColor} nextChapter={nextChapter}>
      <CategoryButton data-testid="course-footer-button" endIcon={<ArrowForward />} onClick={handleChapterCompletion} title={nextChapter?.title} categoryColor={categoryColor} {...userId && !currentChapter.isCompleted ? {
      'aria-label': translate('course.chapter.cta.next.ariaLabel')
    } : {}}>
        {label}
      </CategoryButton>
    </CourseNavigationFooter>;
};
export default CourseFooterWrapper;